import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { css } from 'src/ui/style/css'
import { useTheme } from '@emotion/react'

type Props = {
  active: boolean
  onClick?: () => void
}

const InfoBackdrop: React.FC<Props> = ({ active, onClick }) => {
  const th = useTheme() as any

  const [mounted, setMounted] = useState(false)
  useEffect(() => { setMounted(true) }, [])
  if (!mounted) return null

  const el = (
    <div
      css={css`
        position: fixed;
        inset: 0;
        z-index: 9999;
        background: ${th?.colors?.blackWithOpacity ?? 'rgba(0,0,0,.45)'};
        opacity: ${active ? 1 : 0};
        pointer-events: ${active ? 'auto' : 'none'};
        transition: opacity 180ms ease;
      `}
      onClick={onClick}
      aria-hidden={!active}
      role="presentation"
    />
  )

  const container = typeof document !== 'undefined' ? document.body : null
  return container ? createPortal(el, container) : null
}

export default InfoBackdrop
